import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ElementsComponent } from './elements.component';
import { RouterModule, Routes } from "@angular/router";
import { CustomTableModule } from 'src/app/shared/components/custom-table/custom-table.module';
import { ElementPreviewModule } from '@/shared/components/element-preview/element-preview.module';
import { FeaturedElementModule } from "@/shared/pipes/featured-element/featured-element.module";
import { DateSortingSelectModule } from "@/shared/components/date-sorting-select/date-sorting-select.module";
import { ReactiveFormsModule } from "@angular/forms";
import { ElementDetailsModalComponent } from "@/modules/elements/components/element-details-modal/element-details-modal.component";
import { ElementSummaryComponent } from "@/modules/elements/components/element-details-modal/components/element-summary/element-summary.component";
import { ButtonModule } from "@airnauts/ng-components/button";
import { CustomSectionModule } from "@/shared/components/custom-section/custom-section.module";
import { ChipModule } from "@airnauts/ng-components/chip";
import { SwitchButtonModule } from "@airnauts/ng-components/switch-button";
import { OnboardingModule } from '@/shared/pipes/onboarding/onboarding.module';
import { SelectModule } from "@airnauts/ng-components/select";
import { SectionModule } from "@/shared/components/section/section.module";
import { TableModule } from "@/shared/components/table/table.module";
import { ElementTagComponent } from "@/modules/elements/components/element-details-modal/components/element-tag/element-tag.component";
import { MatDialogModule } from "@angular/material/dialog";
import { ConfirmDialogModule } from "@/shared/components/confirm-dialog/confirm-dialog.module";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatExpansionModule } from "@angular/material/expansion";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { MatIconModule } from "@angular/material/icon";
import { ExpandablePanelModule } from "@/shared/components/accordion/expandable-panel.module";

@NgModule({
  declarations: [
    ElementsComponent,
    ElementDetailsModalComponent,
    ElementSummaryComponent,
    ElementTagComponent,
  ],
  imports: [
    CommonModule,
    CustomTableModule,
    SectionModule,
    ElementPreviewModule,
    FeaturedElementModule,
    DateSortingSelectModule,
    ReactiveFormsModule,
    ButtonModule,
    CustomSectionModule,
    ChipModule,
    SwitchButtonModule,
    OnboardingModule,
    SelectModule,
    SectionModule,
    TableModule,
    MatDialogModule,
    ConfirmDialogModule,
    MatSlideToggleModule,
    MatExpansionModule,
    ClipboardModule,
    MatIconModule,
    ExpandablePanelModule,
  ],
  providers: [],
})
export class ElementsModule { }
